/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { Field } from '@cleartrip/bento';
import { Dropdown, OutsideClickHandler } from 'components/composite';
import { isEmpty } from 'helper/isEmpty';
import { COM_TAB_MAP_ID } from 'constants/travelsafe';
import { TabContext } from 'context/travelsafe';
import {capitalizeFirst} from 'helper/utils';
import { align } from 'helper/flyin';
import { langTranslate } from 'helper/arabic';

function AutoComplete(props) {
	const { initialList = [] , onSelect, inputVal, loading, countriesList = [], ...otherProps } = props;
	const [tab] = useContext(TabContext);
	const [displayList, setDisplayList] = useState(tab === COM_TAB_MAP_ID.DOM_TRAVEL ? initialList : countriesList);
	const [active, setActive] = useState(false);
	const [value, setValue] = useState(isEmpty(inputVal) ? '' : inputVal);
	const [internalLoading, setInternalLoading] = useState(loading);
	let [dropdownList, setDropdownList] = useState([]);
	let DropdownBlock;
	const pathName = window.location.pathname;
	const hostName = window.location.hostname;
	let popularRoutes_DOM_IN = initialList.slice(0, 5);
	let popularRoutes_INT_AE = [
		{"iso3Code":"IND","iso2Code":"IN","name":"india"},
		{"iso3Code":"EGY","iso2Code":"EG","name":"egypt"},
		{"iso3Code":"PAK","iso2Code":"PK","name":"pakistan"},
		{"iso3Code":"PHL","iso2Code":"PH","name":"philippines"},
		{"iso3Code":"ARE","iso2Code":"AE","name":"united arab emirates"}
	];
	let popularRoutes_INT_SA = [
		{"iso3Code":"EGY","iso2Code":"EG","name":"egypt"},
		{"iso3Code":"ARE","iso2Code":"AE","name":"united arab emirates"},
		{"iso3Code":"IND","iso2Code":"IN","name":"india"},
		{"iso3Code":"PAK","iso2Code":"PK","name":"pakistan"},
		{"iso3Code":"KWT","iso2Code":"KW","name":"kuwait"},
		{"iso3Code":"PHL","iso2Code":"PH","name":"philippines"}
	];
	let popularRoutes_INT_IN = [
		{"iso3Code":"IND","iso2Code":"IN","name":"india"},
		{"iso3Code":"ARE","iso2Code":"AE","name":"united arab emirates"},
		{"iso3Code":"MDV","iso2Code":"MV","name":"maldives"},
		{"iso3Code":"GBR","iso2Code":"GB","name":"united kingdom"}
	]; 
	let popularRoutes_INT_Flyin = [
		{"iso3Code":"EGY","iso2Code":"EG","name":"مصر "},
		{"iso3Code":"ARE","iso2Code":"AE","name":"الإمارات العربية المتحدة‎ "},
		{"iso3Code":"IND","iso2Code":"IN","name":"الهند "},
		{"iso3Code":"PAK","iso2Code":"PK","name":"باكستان "},
		{"iso3Code":"KWT","iso2Code":"KW","name":"الكويت ‎"},
		{"iso3Code":"PHL","iso2Code":"PH","name":"الفلبين‎ "}
	]

	let popularRouteList = popularRoutes_INT_IN;
	if((pathName.toLowerCase() === '/travelsafe/ae' || pathName.toLowerCase() === '/travelsafe/ae/') || (hostName === 'www.cleartrip.ae' || hostName === 'cleartrip.ae' || hostName === "qa2.cleartrip.ae")) {
		popularRouteList = popularRoutes_INT_AE
	} else if((pathName.toLowerCase() === '/travelsafe/sa' || pathName.toLowerCase() === '/travelsafe/sa/') || (hostName === 'www.cleartrip.sa' || hostName === 'cleartrip.sa' || hostName === "qa2.cleartrip.sa")) {
		popularRouteList = popularRoutes_INT_SA;
	} else if((pathName.toLowerCase() === '/travelsafe/flyin' || pathName.toLowerCase() === '/travelsafe/flyin/') || (hostName === 'www.flyin.com' || hostName === 'flyin.com' || hostName === "qa2.flyin.com")) {
		if(align() === "rtl") {
			popularRouteList = popularRoutes_INT_Flyin;
		} else {
			popularRouteList = popularRoutes_INT_SA;
		}
	} else if(tab === COM_TAB_MAP_ID.DOM_TRAVEL) {
		popularRouteList = popularRoutes_DOM_IN;
	}

	if (dropdownList) {
		DropdownBlock = dropdownList.map((item, idx) => {
			return (<Dropdown.Item key={idx} onClick={() => onSelectItem(item)}>
				{capitalizeFirst(item.name)}{" "}({item.airportCode || item.iso3Code})
			</Dropdown.Item>)
    });
	}

	useEffect(() => {
		setInternalLoading(loading);
		setPopularRouteList();
		setDropdownList(popularRouteList);
		setValue(inputVal);
	}, [loading, inputVal]);

	useEffect(() => {
		setDisplayList(tab === COM_TAB_MAP_ID.DOM_TRAVEL ? initialList : countriesList);
		setPopularRouteList();
		setDropdownList(popularRouteList);
		setValue('');
		onSelect({ name: '', code: '', isCountry: false });
	}, [tab]);

	function setPopularRouteList() {
		if((pathName.toLowerCase() === '/travelsafe/ae' || pathName.toLowerCase() === '/travelsafe/ae/') || (hostName === 'www.cleartrip.ae' || hostName === 'cleartrip.ae')) {
			popularRouteList = popularRoutes_INT_AE
		} else if((pathName.toLowerCase() === '/travelsafe/sa' || pathName.toLowerCase() === '/travelsafe/sa/') || (hostName === 'www.cleartrip.sa' || hostName === 'cleartrip.sa')) {
			popularRouteList = popularRoutes_INT_SA;
		} else if((pathName.toLowerCase() === '/travelsafe/flyin' || pathName.toLowerCase() === '/travelsafe/flyin/') || (hostName === 'www.flyin.com' || hostName === 'flyin.com')) {
			if(align() === "rtl") {
				popularRouteList = popularRoutes_INT_Flyin;
			} else {
				popularRouteList = popularRoutes_INT_SA;
			}
		} else if(tab === COM_TAB_MAP_ID.DOM_TRAVEL) {
			popularRouteList = popularRoutes_DOM_IN;
		}
	}

	function filterResults(e) {
		const sParam = e.target.value;
		setValue(sParam);
		if (sParam.length === 0) setDropdownList(popularRouteList);
		else {
			let filteredArr = displayList.filter(
				(item) => (item.airportCode && item.airportCode.toLowerCase().startsWith(sParam.toLowerCase())) || item.name.toLowerCase().startsWith(sParam.toLowerCase()) || (item.iso3Code && item.iso3Code.toLowerCase().startsWith(sParam.toLowerCase())) || (item.iso2Code && item.iso2Code.toLowerCase().startsWith(sParam.toLowerCase())) 
			);
			if (!filteredArr.length) {
				setActive(true);
			} else {
				setActive(true);
			}
			setDropdownList(filteredArr);
		}
		
		onSelect({ name: '', code: '', isCountry: false });
	}

	function onSelectItem(selected) {
		onSelect(selected);
		setValue(`${capitalizeFirst(selected.name)} (${selected.airportCode || selected.iso3Code})`);
		setActive(false);
	}

	return (
		<OutsideClickHandler className='p-relative' onOutsideClick={() => setActive(false)}>
			<Field {...otherProps} value={value} onChange={(e) => filterResults(e)} onClick={() => setActive(true)} Autocomplete="off"/>
			{active && <Dropdown loading={internalLoading}>{DropdownBlock.length === 0 ? <Dropdown.Item className="fs-4 c-neutral-900">{langTranslate('No Countries Found')}</Dropdown.Item> : DropdownBlock}</Dropdown>}
		</OutsideClickHandler>
	);
}

export default AutoComplete;